/**
 * The bold style's page container: one width and one gutter for every bold
 * section, the header and the footer, so every left edge on a bold page lines
 * up. Content stops at 1200px; the gutter grows from 20px on a phone to 32px on
 * a tablet and 48px on a desktop.
 */
const BOLD_CONTAINER_CLASS =
  "jobsite:mx-auto jobsite:w-full jobsite:max-w-[81rem] jobsite:px-5 jobsite:md:px-8 jobsite:lg:px-12";

export { BOLD_CONTAINER_CLASS };
